import { Interweave } from 'interweave'
import styled from 'styled-components'

import { RichTextDisplayBlock as RichTextDisplayBlockType } from '../../types/blueprint'
import { Unanswered } from '../DisplayBlock.style'

const OverrideWrapper = styled.div`
  color: ${({ theme }) => theme.colour.secondary.base};

  & p,
  & span {
    color: ${({ theme }) => theme.colour.secondary.base};
  }
`

type Props = {
  block: RichTextDisplayBlockType
}

export const RichTextDisplayBlock: React.FC<Props> = ({ block }) => {
  const { content } = block

  if (!content) return <Unanswered />

  return (
    <OverrideWrapper>
      <Interweave content={content} />
    </OverrideWrapper>
  )
}
